import { render, staticRenderFns } from "./EditorMergeTagsButton.vue?vue&type=template&id=2509ed0d"
import script from "./EditorMergeTagsButton.vue?vue&type=script&lang=js"
export * from "./EditorMergeTagsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports